var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { staticClass: "form-group" },
    [
      _c(
        "label",
        {
          staticClass: "form-control-placeholder",
          attrs: { for: _vm.input.url }
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
        : [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDirty,
                  expression: "isDirty"
                }
              ],
              staticClass: "fa fa-times",
              on: { click: _vm.reset }
            })
          ],
      _vm._v(" "),
      _c("md-input", {
        staticClass: "Typeahead__input",
        attrs: {
          id: _vm.input.url,
          type: "text",
          disabled: "disabled == true",
          autocomplete: "off"
        },
        on: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.down.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.up.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.hit.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.reset.apply(null, arguments)
            }
          ],
          input: _vm.update
        },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasItems,
              expression: "hasItems"
            }
          ],
          staticClass: "search-typeahead"
        },
        [
          _c(
            "ul",
            _vm._l(_vm.items, function(item, $item) {
              return _c(
                "li",
                {
                  staticClass: "activeClass($item)",
                  on: {
                    mousedown: _vm.hit,
                    mousemove: function($event) {
                      return _vm.setActive($item)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.Name))
                  ])
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm.items.length === 0 && _vm.query.length > 2
        ? _c("div", { staticClass: "search-typeahead" }, [
            _c("ul", [_c("li", [_c("span", [_vm._v("No results found")])])])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-306208c3", { render: render, staticRenderFns: staticRenderFns })
  }
}